import { inventarioInicial } from '../data/inventarioInicial';

export function exportInventoryToJSON() {
  // Transformar los datos al formato del backend
  const backendData = inventarioInicial.map(item => ({
    productId: item.id,
    fecha: item.fecha,
    categoria: item.categoria,
    producto: item.producto,
    unidad: item.unidad,
    proveedor: item.proveedor,
    entradas: item.entradas,
    fechaEntrada: item.fechaEntrada,
    fechaCaducidad: item.fechaCaducidad || '',
    salidas: item.salidas,
    mermas: item.mermas,
    stockFinal: item.stockFinal,
    stockMinimo: item.stockMinimo,
    stockMaximo: item.stockMaximo,
    puntoReorden: item.puntoReorden,
    costoUnitario: item.costoUnitario,
    tipoProducto: item.tipoProducto
  }));

  // Crear el contenido JSON
  const jsonContent = JSON.stringify(backendData, null, 2);
  
  // Crear y descargar el archivo
  const blob = new Blob([jsonContent], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'inventarioInicial.json';
  a.click();
  URL.revokeObjectURL(url);
  
  console.log(`Exportados ${backendData.length} productos`);
  
  return jsonContent;
}

// Para copiar al portapapeles
export function copyInventoryToClipboard() {
  const backendData = inventarioInicial.map(item => ({
    productId: item.id,
    fecha: item.fecha,
    categoria: item.categoria,
    producto: item.producto,
    unidad: item.unidad,
    proveedor: item.proveedor,
    entradas: item.entradas,
    fechaEntrada: item.fechaEntrada,
    fechaCaducidad: item.fechaCaducidad || '',
    salidas: item.salidas,
    mermas: item.mermas,
    stockFinal: item.stockFinal,
    stockMinimo: item.stockMinimo,
    stockMaximo: item.stockMaximo,
    puntoReorden: item.puntoReorden,
    costoUnitario: item.costoUnitario,
    tipoProducto: item.tipoProducto
  }));

  const jsonContent = JSON.stringify(backendData, null, 2);
  
  navigator.clipboard.writeText(jsonContent).then(() => {
    console.log('Datos copiados al portapapeles');
    alert('Datos del inventario copiados al portapapeles!');
  }).catch(err => {
    console.error('Error copiando al portapapeles:', err);
  });
}